import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import toast from 'react-hot-toast';
export { default as toast } from 'react-hot-toast';
import { Alert } from './Alert.js';

var createAlert = function (_a) {
    var _b = _a.duration, duration = _b === void 0 ? Infinity : _b, content = _a.content, onDismiss = _a.onDismiss, _c = _a.position, position = _c === void 0 ? "top-center" : _c, alertProps = __rest(_a, ["duration", "content", "onDismiss", "position"]);
    var getDismiss = function (id) { return function () {
        toast.dismiss(id);
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }; };
    var toastStyles = {
        display: "block",
        padding: 0,
        maxWidth: "min-content",
        boxShadow: "none",
        background: "transparent",
    };
    return toast(function (t) { return (jsx(Alert, __assign({ onDismiss: getDismiss(t.id) }, alertProps, { children: content }))); }, {
        duration: duration,
        position: position,
        style: toastStyles,
    });
};

export { createAlert };
//# sourceMappingURL=createAlert.js.map
